import { Http, RequestOptions, Headers } from '@angular/http';
import { AuthService, User } from '../user/auth.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { ConfigurationService } from '../shared/configuration.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { ToastType } from '../toast/toast.enum';
import { environment } from '../../environments/environment';
import { Contribution } from '../track/contribution';
import { Gift } from '../gift/gift';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';
@Component({
  selector: 'app-account-referral',
  templateUrl: './account-referral.component.html',
  styleUrls: ['./account-referral.component.scss']
})
export class AccountReferralComponent  implements OnInit {
  isConnected: boolean;
  registry: Registry;
  isLoaded = false;
  processing = false;
  isVerified: boolean;
  stripeAccountId: string;
  baseUrl: string;
  dupeStripeAccount = false;
  coppied = false;
  isLive: boolean;
  stripeClientId: string;
  settings: Settings;
  user: User;
  copyLabel = 'Copy'
  referralUrl: string;
  payoutsEnabled = undefined;
  showPopup= false;
  gifts: Gift[];
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _configuration: ConfigurationService,
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private _http: Http,
    private _registryService: RegistryService,
    private route: ActivatedRoute,
    private _router: Router
  ) {

  
    this._authService.user.takeUntil(this.ngUnsubscribe).subscribe(user => {
      if (user){
      this.user = user;
      this.referralUrl = `www.hitchd.com?rkq=`+user.uid   
      }
      
    });

    

    this.baseUrl = this._configuration.baseUrl;
    this.stripeClientId = this._configuration.stripeClientId;

    

  }

  close(){
    if(!this.showPopup) {
      return;
    }
    
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  
      this.showPopup = false;
 
  }
  ngOnInit() {




    this._registryService.setScrollY(1);

    this.gifts = this.route.snapshot.data.gifts;
    this._registryService.showGenericPopup$.subscribe(popupType => {

      if (popupType == "referral"){
      this.showPopup = true;
      this.copyLabel = 'Copy'
      const body = document.getElementsByTagName('body')[0];    
      body.style.overflow = 'hidden';
      this._analyticsService.trackEvent('Referral popup viewed', {    
      });
      } else {
        this.close();
      }
  
    });

  }



  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers});
    return options;
  }

  getCountry(country: string) {
    switch (country) {
      case 'AU': {
        return 'Australia';
      }
      case 'GB': {
        return 'UK';
      }
      case 'US': {
        return 'United States';
      }
      case 'NZ': {
        return 'New Zealand';
      }
      case 'JP': {
        return 'Japan';
      }
      case 'CA': {
        return 'Canada';
      }
    }
  }

  setupStripe(): Promise<any> {
    const country = this.registry.country;
    const currency = this.registry.currency;
    const registryName = this.registry.registryName;
    const email = encodeURI(this.user.email.replace(/[\n\t\r]/g, ''));
    //
    //   + 'country=' + country
    //   + '&currency=' + currency
    //   + '&registryName=' + registryName
    //   + '&email=' + email.trim()

    return this._http
      .post(environment.firebase.clouldFunctionHost + '/createStripeAccount', {
        country: country,
        currency: currency,
        registryName: registryName,
        email: email
      })
      .toPromise()
      .catch((e: any) => {
        if (
          e.type === 'StripeInvalidRequestError' &&
          e.code === 'account_already_exists'
        ) {
        }
        this.dupeStripeAccount = true;
        this.processing = false;
      })
      .then((response: any) => {
        const stripeResponse: any = response.json();
        // stripe

        this._registryService.sendFbTrackEvent('Stripe connected');
        this._analyticsService.trackEvent('stripeConnected', {
          registryUrl: 'https://www.hitchd.com/' + registryName
        });

        this._analyticsService.trackEvent('registryStatus', {
          isLive: this.registry.isLive
        });

        this._analyticsService.update(
          {
          stripeConnected: true,
          isLive: true,
          registryUrl: 'https://www.hitchd.com/' + registryName }
           );

        const accountId = stripeResponse.id;
        const publicKey = stripeResponse.keys.publishable;

        this.settings.stripeAccountId = accountId;
        this.settings.stripePublicKey = publicKey;
        return this._registryFirebaseService.saveSettings(this.settings);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

sendAdwordConversion(){

  const gtag = window['gtag'];
  if (!gtag){
    return;
  }

  gtag('event', 'conversion', {
    'send_to': 'AW-784025651/A1_qCJKMrKABELOQ7fUC',
    'signup': true,
    'published': true
  });
}


  updateRegistryLiveStatus(isLive: boolean) {
    this.processing = true;
    if (!this.settings.stripeAccountId) {
      this.setupStripe().then(x => {
        this.processing = false;
        this.registry.isLive = isLive;

        this._registryService.sendFbTrackEvent('Registry published');
     //   this._analyticsService.heap('Stripe Connected');
        this._registryFirebaseService.saveRegistry(this.registry);

      });
    } else {
      if (isLive) {
        setTimeout(() => {
          this.registry.isLive = isLive;
          this._registryFirebaseService.saveRegistry(this.registry);
          this.processing = false;
          this.isLive = isLive;
        }, 1 * 1000);

        this.sendAdwordConversion();
      } else {
        this.registry.isLive = isLive;
        this._registryFirebaseService.saveRegistry(this.registry);
        this.processing = false;
        this.isLive = isLive;
      }
      this._analyticsService.update({ isLive: isLive });
    }

    if (isLive) {
      localStorage.setItem('toast_' + ToastType.share, 'true');
    }
  }

  copy() {
    this._analyticsService.trackEvent('Referral copied', {    
      refUrl: this.referralUrl
    });
    this.setClipboardText(this.referralUrl);
    this.copyLabel = "Copied";
  }

  setClipboardText(text) {
    const id = 'mycustom-clipboard-textarea-hidden-id';
    let existsTextarea: any = document.getElementById(id);

    if (!existsTextarea) {
      const textarea: any = document.createElement('textarea');
      textarea.id = id;
      // Place in top-left corner of screen regardless of scroll position.
      textarea.style.position = 'fixed';
      textarea.style.top = 0;
      textarea.style.left = '-10px';

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textarea.style.width = '1px';
      textarea.style.height = '1px';

      // We don't need padding, reducing the size if it does flash render.
      textarea.style.padding = 0;

      // Clean up any borders.
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.boxShadow = 'none';

      // Avoid flash of white box if rendered for any reason.
      textarea.style.background = 'transparent';
      document.querySelector('body').appendChild(textarea);

      existsTextarea = document.getElementById(id);
    } else {
    }

    existsTextarea.value = text;
    existsTextarea.select();

    try {
      const status = document.execCommand('copy');

      if (!status) {
      } else {
        this.coppied = true;

        setTimeout(() => {
          this.coppied = false;
        }, 2 * 1000);
      }
    } catch (err) {}
  }
}



// WEBPACK FOOTER //
// ./src/app/account-referral/account-referral.component.ts